import { render, staticRenderFns } from "./PaySchedulesReturnedSalaries.vue?vue&type=template&id=10aefa88&"
import script from "./PaySchedulesReturnedSalaries.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySchedulesReturnedSalaries.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports